import React from "react";
import { Button, Modal, ModalFooter, ModalHeader } from "reactstrap";
import {
  APIDeleteSuccessMsg,
  getItemDeleteSuccessMsg,
} from "../../../../Constant/Message";
import { toast } from "react-toastify";
import { timeToast } from "../../../../Constant";

const DeleteCapaianSS = ({
  deleteModalOpen,
  toggleDeleteModal,
  selectedCapaian,
  getCapaianSS,
  axiosInstance,
}) => {
  const deleteDaftarCapaianSS = async () => {
    const response = await axiosInstance.delete(
      `capaian-ss/${selectedCapaian.id}`,
      selectedCapaian.id
    );
    if (response.status === 204) {
      console.log(APIDeleteSuccessMsg);
      toggleDeleteModal();
      toast.success(getItemDeleteSuccessMsg("Capaian SS"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      toggleDeleteModal(selectedCapaian);
      getCapaianSS();
    }
  };

  return (
    <Modal
      isOpen={deleteModalOpen}
      toggle={() => toggleDeleteModal(selectedCapaian)}
    >
      <ModalHeader>
        Apakah anda yakin ingin menghapus capaian yang dipilih?
      </ModalHeader>
      <ModalFooter>
        <Button
          color="primary"
          type="button"
          onClick={() => toggleDeleteModal(selectedCapaian)}
        >
          Batal
        </Button>
        <Button
          type="button"
          color="danger"
          onClick={() => deleteDaftarCapaianSS()}
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteCapaianSS;
